import { AppError } from "config/errors";
import { fetchTriviaQuery } from "gql/queries/trivia";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTrivia = createAsyncThunk("trivia/fetch", async (_, { rejectWithValue }) => {
  try {
    const res = await fetchTriviaQuery();

    return res.data.triviaQuestions;
  } catch (err) {
    return rejectWithValue(AppError.from(err).toPlainObject());
  }
});
